import { css } from 'styled-components'

import { breakpoints } from '@/config/layout'

const VisibleScrollbarStyle = css`
  overflow-y: auto;
  min-height: 0;

  @media ${breakpoints.toS} {
    &::-webkit-scrollbar {
      display: none;
    }
  }
  @media ${breakpoints.m} {
    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.5);
      box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    }
  }
`

export { VisibleScrollbarStyle }
